<template>
  <div class="height-400px">
    <div class="level columns">
      <div class="level-left column is-4">
        <div class="columns">
          <div class="column is-12">
            <b-field :label="$t('popUpParametrageReseauTempoDispo.etatSouhaite')"
                     class="obligatoire">
              <b-select v-model="parametrageSelection.etatSouhaiteSelect" expanded>
                <option v-for="etatSouhaite in ETAT_SOUHAITE"
                        :value="etatSouhaite.key"
                        :key="etatSouhaite.key">
                  {{ $t(etatSouhaite.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
      <div class="column is-6 level-right columns">
        <div class="column is-narrow bfieldWhitoutLabel">
          <legende-reseau-tempo class="mgr-10px"/>
          <exportExcelButton
            :perm="permCatalogue.exporter"
            :action="exportExcel"
            class="is-inline-block"/>
        </div>
      </div>
    </div>
    <v-client-table :data=reseauxTempoDispo :columns="columns" :options="options"
                    class="tableRecapReseauDispo"
                    ref="tableLignesCommande">
      <div slot="reference" slot-scope="props">
        <router-link-blank :to="{ name: 'c.bodac.catalogue-reseau',
        params: { id: props.row.id, isFromListeProduitReseau: false }}" class="lien"
                           :class="{'text-access-no-permission':
                     !checkPermissions(permCatalogue.lecture)}"
                           :message="props.row.reference">
        </router-link-blank>
      </div>
      <div slot="libelle" slot-scope="props">
        <b-tooltip :label="props.row.libelle" position="is-right">
          <p class="ellipsis"> {{ props.row.libelle }} </p>
        </b-tooltip>
      </div>
      <div slot="etat" slot-scope="props" class="disponibiliteSemaine align-items-flex-end">
        <cellule-option-blocage-info :affectations="props.row.affectations"
                                     :nb-face-non-dispo="props.row.facesNonDispo"
                                     :qte-faces-prevues="props.row.facesPrevues"/>
      </div>
      <div slot="tarif" slot-scope="props" class="is-pulled-right" v-if="props.row.tarif">
        {{ props.row.tarif}}
      </div>
      <div slot="frais" slot-scope="props" class="is-pulled-right" v-if="props.row.frais">
        {{ props.row.frais}}
      </div>
      <div slot="taxe" slot-scope="props" class="is-pulled-right" v-if="props.row.taxe">
        {{ props.row.taxe}}
      </div>
      <div slot="facesPrevues" slot-scope="props" class="is-pulled-right">
        {{ props.row.facesPrevues}}
      </div>
      <div slot="facesReelles" slot-scope="props" class="is-pulled-right">
        {{ props.row.facesReelles}}
      </div>
    </v-client-table>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import createLignesCommandeForRecap from '@/services/outils/produitReseauTempoDispo/createLignesCommandeForRecap';
import messageErreur from '@/services/general/messageErreur';
import { get } from '@/api/produit/produitLocation';
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import sortLignesCommande from '@/services/outils/produitReseauTempoDispo/sortLignesCommande';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { ETAT_SOUHAITE } from '@/configuration/optionBlocage/optionBlocage';
import celluleOptionBlocageInfo from '@/components/general/celluleOptionBlocageInfo';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import legendeReseauTempo from '@/components/planning/legendeReseauTempo';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { SET_LIGNES_COMMANDE } from '@/store/modules/produitReseauTempo-mutation-type';
import exportListReseauxTempoDispoToExcel
  from '@/services/excel/produitReseauTempoDispo/exportListReseauxTempoDispoToExcel';
import formatListReseauTempoDispo from '@/services/outils/produitReseauTempoDispo/formatListReseauTempoDispo';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT } from '@/configuration/societe/societe';

const ProduitReseauTempo = createNamespacedHelpers('produitReseauTempo');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'ReseauTempoParametrageRecap',
  props: {
    weeksSelect: {
      type: Array,
      required: true,
    },
    parametrageSelection: {
      type: Object,
      required: true,
    },
    produitsLocation: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      ETAT_SOUHAITE: ETAT_SOUHAITE,
      permCatalogue: CATALOGUE,
      reseauxTempoDispo: [],
    };
  },
  components: {
    celluleOptionBlocageInfo,
    routerLinkBlank,
    legendeReseauTempo,
    exportExcelButton,
  },
  computed: {
    ...ProduitReseauTempo.mapGetters({
      panier: 'panier',
      lignesCommande: 'lignesCommande',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$t('popUpParametrageReseauTempoDispo.tab.reference'),
          libelle: this.$t('popUpParametrageReseauTempoDispo.tab.libelle'),
          ville: this.$t('popUpParametrageReseauTempoDispo.tab.ville'),
          format: this.$t('popUpParametrageReseauTempoDispo.tab.format'),
          facesPrevues: this.$t('popUpParametrageReseauTempoDispo.tab.facePrevues'),
          facesReelles: this.$t('popUpParametrageReseauTempoDispo.tab.faceReelles'),
          dateDebut: this.$t('popUpParametrageReseauTempoDispo.tab.depart'),
          tarif: this.$t('popUpParametrageReseauTempoDispo.tab.tarif'),
          taxe: this.$t('popUpParametrageReseauTempoDispo.tab.taxe'),
          frais: this.$t('popUpParametrageReseauTempoDispo.tab.frais'),
          etat: this.$t('popUpParametrageReseauTempoDispo.tab.etat'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        columnsClasses: {
          etat: 'width-100',
          libelle: 'colonneLibelle',
        },
        sortable: ['reference', 'libelle', 'ville', 'format', 'facesPrevues', 'facesReelles', 'dateDebut', 'tarif', 'frais', 'taxe'],
      };
    },
    columns() {
      return ['reference', 'libelle', 'ville', 'format', 'facesPrevues', 'facesReelles', 'dateDebut', 'tarif', 'taxe', 'frais', 'etat'];
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...ProduitReseauTempo.mapMutations({
      setLignesCommandes: SET_LIGNES_COMMANDE,
    }),
    exportExcel() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        exportListReseauxTempoDispoToExcel(this.reseauxTempoDispo, this.$i18n);
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n, this.$i18n.t('popUpParametrageReseauTempoDispo.errors.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.ETAT_SOUHAITE.splice(3, 1);
      await this.loadParametres([PARAMETRES_KEYS.format]);
      let produitLoc = null;
      let allProduitsLoc = [];
      if (this.parametrageSelection.produitLoc !== PRODUIT_ID_LOCATION_PAR_DEFAUT) {
        produitLoc = (await get(this.parametrageSelection.produitLoc)).data.result;
      } else {
        produitLoc = PRODUIT_ID_LOCATION_PAR_DEFAUT;
        allProduitsLoc = this.produitsLocation;
      }
      const lignesCommande = await createLignesCommandeForRecap(
        this.panier.map(panier => panier.id),
        this.parametrageSelection.niveauDeDispo,
        produitLoc,
        [...new Set(this.weeksSelect.map(week => week.anneeSemaine))],
        allProduitsLoc,
        this.societeActiveId,
      );
      sortLignesCommande(lignesCommande);
      this.setLignesCommandes(lignesCommande);
      this.reseauxTempoDispo = formatListReseauTempoDispo(
        lignesCommande, this.parametre(PARAMETRES_KEYS.format), this.$i18n,
      );
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
